import { config } from 'client/hooks/config';
import type * as api from 'common/types/api';
import { Api } from 'common/utils/api';
import { useMutation } from 'react-query';

type Response = api.ApiResponse;

export interface TemplatePayload {
    id: number;
}

export const useSendTemplate = () => {
    const { path: updatePath } = config.templates.send();
    const sendMutation = useMutation((data: TemplatePayload) => Api.post<Response>({ path: updatePath, body: data }));
    return {
        sendTemplate: sendMutation.mutateAsync,
    };
};
